import { render } from "./ConfigurationPanelTabContentItem.vue?vue&type=template&id=aba65e38&scoped=true"
import script from "./ConfigurationPanelTabContentItem.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPanelTabContentItem.vue?vue&type=script&lang=ts"

import "./ConfigurationPanelTabContentItem.vue?vue&type=style&index=0&id=aba65e38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-aba65e38"

export default script